import React, { useState } from "react";
import { Col, Row } from "antd";

import BlogItem from "./../../Common/Components/BlogItem";
import BlogItemTwo from "./../../Common/Components/BlogItemTwo";
import { DraggableBox } from "modules/Common/Components/DraggableBox";
import CheckBlogItem from "modules/Common/Components/CheckBlogItem";
import CheckBlogItemNoImage from "modules/Common/Components/CheckBlogItemNoImage";
import ArticlesListContainer from "./ArticlesListContainer";

const ArticlesHybridMirrorContainer = (props) => {
  const { articles, swap, inEditionSmartSourced, isCampaign } = props;

  return (
    <React.Fragment>
      {articles.length > 3 ? (
        <div className="padding-top-md padding-bottom-md">
          <Row gutter={{ xs: 24, sm: 24, md: 24, lg: 24 }}>
            <Col className="gutter-row" span={12}>
              <div className={`small-three ${articles.length == 4 ? "small-two-only" : ""}`}>
                {articles.slice(0, 3).map((article, index) => (
                  <DraggableBox key={index} articleId={article.id} blogItem={article}>
                    <BlogItemTwo
                      isCampaign={isCampaign}
                      index={index}
                      imgHeight="95"
                      imgWidth="95"
                      key={article.id}
                      articleId={article.id}
                      title={article.title}
                      imgUrl={article.image_url}
                      publishDate={article.publish_date}
                      website={article.website}
                      entities={article.entities}
                      description={article.description}
                      link={article.link}
                      isCurated={article.is_curated}
                      isCMS={article.is_cms}
                      isFav={article.is_favourite}
                      inEditionSmartSourced={inEditionSmartSourced}
                      companyName={article.companyName}
                      categoryColor={article.alerts}
                      categoryTitle={article.alerts}
                      fullDescription={article.fullDescription}
                      inArticlesContainer={true}
                    />
                  </DraggableBox>
                ))}
              </div>
            </Col>
            <Col className="gutter-row" span={12}>
              <DraggableBox articleId={articles[3].id} blogItem={articles[3]}>
                {articles[3].image_url === "" ? (
                  <CheckBlogItemNoImage
                    isCampaign={isCampaign}
                    imgHeight="295"
                    imgWidth="613"
                    imgHeightSm={"210px"}
                    articleId={articles[3].id}
                    title={articles[3].title}
                    imgUrl={articles[3].image_url}
                    publishDate={articles[3].publish_date}
                    website={articles[3].website}
                    entities={articles[3].entities}
                    description={articles[3].description}
                    link={articles[3].link}
                    isCurated={articles[3].is_curated}
                    isCMS={articles[3].is_cms}
                    isFav={articles[3].is_favourite}
                    hybridContainer={true}
                    inEditionSmartSourced={inEditionSmartSourced}
                    companyName={articles[3].companyName}
                    categoryColor={articles[3].alerts}
                    categoryTitle={articles[3].alerts}
                    fullDescription={articles[3].fullDescription}
                  />
                ) : (
                  <CheckBlogItem
                    isCampaign={isCampaign}
                    imgHeight="295"
                    imgWidth="613"
                    imgHeightSm={"210px"}
                    articleId={articles[3].id}
                    title={articles[3].title}
                    imgUrl={articles[3].image_url}
                    publishDate={articles[3].publish_date}
                    website={articles[3].website}
                    entities={articles[3].entities}
                    description={articles[3].description}
                    link={articles[3].link}
                    isCurated={articles[3].is_curated}
                    isCMS={articles[3].is_cms}
                    isFav={articles[3].is_favourite}
                    inEditionSmartSourced={inEditionSmartSourced}
                    companyName={articles[3].companyName}
                    categoryColor={articles[3].alerts}
                    categoryTitle={articles[3].alerts}
                    fullDescription={articles[3].fullDescription}
                  />
                )}
              </DraggableBox>
            </Col>
          </Row>
        </div>
      ) : (
        <div className="">
          <ArticlesListContainer articles={articles} />
        </div>
      )}
    </React.Fragment>
  );
};

export default ArticlesHybridMirrorContainer;
